import type { Dayjs } from 'dayjs'

export type TimeObject = {
  hours: number
  minutes: number
}

export type DateThreshold = {
  start: Dayjs
  end: Dayjs
}

export const EMPTY_TIME_OBJECT = {
  hours: 0,
  minutes: 0,
}

export const START_TIME_OBJECT = {
  hours: 0,
  minutes: 0,
}

export const END_TIME_OBJECT = {
  hours: 23,
  minutes: 59,
}
